import { LayersIcon, ToggleLeftIcon, ToggleRightIcon } from "lucide-react";
import type { ExpenseCategoryDTO } from "../api/client";
import type { ExpenseCategoryStatusFilter } from "./ExpenseCategoriesFilter";
import { ExpenseStatCard } from "./ExpenseStatCard";

type ExpenseCategorySummaryCardsProps = {
  categories: ExpenseCategoryDTO[];
  isLoading: boolean;
  statusFilter: ExpenseCategoryStatusFilter;
  onStatusFilterChange: (status: ExpenseCategoryStatusFilter) => void;
};

export function ExpenseCategorySummaryCards({
  categories,
  isLoading,
  statusFilter,
  onStatusFilterChange,
}: ExpenseCategorySummaryCardsProps) {
  const total = categories.length;
  const activeCount = categories.filter((category) => category.isActive).length;
  const inactiveCount = total - activeCount;
  const activeRate =
    total > 0 && !isLoading
      ? `${Math.round((activeCount / total) * 100)}% ຂອງທັງໝົດ`
      : undefined;

  const toggleStatus = (status: ExpenseCategoryStatusFilter) => {
    onStatusFilterChange(
      statusFilter === status && status !== "all" ? "all" : status,
    );
  };

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <ExpenseStatCard
        title="ຫມວດທັງໝົດ"
        value={total.toLocaleString("lo-LA")}
        isLoading={isLoading}
        icon={LayersIcon}
        tone="default"
        active={statusFilter === "all"}
        onClick={() => onStatusFilterChange("all")}
      />

      <ExpenseStatCard
        title="ໃຊ້ງານ"
        value={activeCount.toLocaleString("lo-LA")}
        meta={activeRate}
        metaAccent
        isLoading={isLoading}
        icon={ToggleRightIcon}
        tone="active"
        active={statusFilter === "active"}
        onClick={() => toggleStatus("active")}
      />

      <ExpenseStatCard
        title="ບໍ່ໃຊ້ງານ"
        value={inactiveCount.toLocaleString("lo-LA")}
        isLoading={isLoading}
        icon={ToggleLeftIcon}
        tone="inactive"
        active={statusFilter === "inactive"}
        onClick={() => toggleStatus("inactive")}
      />
    </div>
  );
}
